const postGroupsStr = {
  postGroups: 'Added group',
  postGroups1: ' has been successfully added',
  toastrError: 'Name already registered',
  toastrError1: 'Enter another name'
};

export default postGroupsStr;
